import React, { useMemo, useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import * as moment from 'moment';
import 'moment/locale/pt-br';

import './index.css';

function SalvarBalloon(props) {
  moment.locale('pt-br');
  const [tick, setTick] = useState(false); // Tick para atualização da página

  const handleTime = useMemo(() => {
    const difference = moment(props.bot.lastUpdate || new Date()).fromNow();
    return difference;
  }, [props.bot.lastUpdate, tick]);

  useEffect(() => {
    // Atualiza de 1min em 1min
    const timer = setTimeout(() => {
      setTick(!tick);
    }, 60000);
    return () => clearTimeout(timer);
  }, [tick]);

  const handleText = () => {
    return `
            Todas as Alterações feitas são
            salvas automaticamente
            <br />
            <br />
            A última edição foi ${handleTime}`;
  };

  const handlePosition = (position) => {
    return {
      top: position.top,
      left: position.left - 80,
    };
  };

  return (
    <div>
      <div data-tip={handleText()} data-for={props.id}>
        {' '}
        {props.children}{' '}
      </div>
      <ReactTooltip
        id={props.id}
        className="salvar-baloon"
        place="top"
        type="dark"
        effect="solid"
        multiline
        overridePosition={handlePosition}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SalvarBalloon)
);
